import type { Hint } from "./types";
import { findAllSolutions } from "./solver";

function getCombinations(n: number, k: number): number[][] {
  const results: number[][] = [];
  const combo: number[] = [];

  function recurse(start: number): void {
    if (combo.length === k) {
      results.push([...combo]);
      return;
    }
    for (let i = start; i < n; i++) {
      combo.push(i);
      recurse(i + 1);
      combo.pop();
    }
  }

  recurse(0);
  return results;
}

export function findOptimalPath(
  solution: readonly number[],
  hints: readonly Hint[],
  digitRange: [number, number] = [0, 9],
): number[] {
  if (hints.length === 0) {
    return [];
  }

  const codeLength = solution.length;
  const solutionKey = solution.join(",");

  for (let size = 1; size <= hints.length; size++) {
    const combos = getCombinations(hints.length, size);
    for (const combo of combos) {
      const subset = combo.map((i) => hints[i]);
      const solutions = findAllSolutions(codeLength, subset, digitRange);
      if (
        solutions.length === 1 &&
        solutions[0].join(",") === solutionKey
      ) {
        return combo;
      }
    }
  }

  return hints.map((_, i) => i);
}
